export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center pt-16 overflow-hidden bg-background-50"
    >
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full pt-8 md:pt-12 lg:pt-0">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
              日韩影视 · 高清流畅
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              日韩影视网 - 免费日韩电影在线观看
            </h1>
            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-5">
              经典大片与新片速递，急速播放一网打尽
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl">
              日韩影视网专注为影迷提供最新最全的日本电影免费观看与韩国电影免费高清资源。每日更新热播日韩电影，涵盖动作、爱情、悬疑、动画、历史等多种题材，支持高清画质急速播放，无需注册即可畅享免费日韩电影在线观看体验。无论是经典回顾还是新片速递，日韩影视网都是你追剧看片的最佳选择。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-film-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">10000+</div>
                  <div className="text-xs text-foreground-500">影片资源</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-refresh-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">片源同步</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-4k-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">高清画质</div>
                  <div className="text-xs text-foreground-500">急速流畅</div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer no-underline hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-medium text-sm whitespace-nowrap cursor-pointer no-underline hover:border-primary-300 hover:text-primary-600 transition-colors"
              >
                <i className="ri-grid-line text-lg"></i>
                分类浏览
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:w-auto flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20featuring%20Japanese%20and%20Korean%20film%20aesthetics%2C%20dramatic%20lighting%20with%20warm%20crimson%20and%20golden%20tones%2C%20film%20reel%20elements%2C%20modern%20minimalist%20composition%2C%20dark%20theater%20atmosphere%20with%20soft%20glow%2C%20elegant%20typography%20space%2C%20artistic%20movie%20poster%20style%2C%20high%20contrast%2C%20rich%20textures%2C%20professional%20cinematography%20vibe&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                alt="日韩影视网 - 免费日韩电影在线观看主视觉"
                className="w-full h-full object-cover rounded-2xl"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-primary-500/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}